import React from 'react';
import { AdminSettings } from '../../components/settings/AdminSettings';

export const AdminSettingsPage: React.FC = () => {  
  return (
    <AdminSettings />
  );
};

export default AdminSettingsPage; // Vous pouvez garder cette ligne aussi pour supporter les deux types d'importation
